import axios from "axios";
import { apiUrls } from "../../config/apiUrls";

export const authService = {
    getToken: (authorizationCode: any, loginCallbackUrl: string, grantType: string, clientId: string, codeVerifier: string | null, thenCallback: (data: any) => void, errorCallback: () => void) => {
        axios.post(`${apiUrls.getToken}`, {
            AuthorizationCode: authorizationCode,
            RedirectUri: loginCallbackUrl,
            GrantType: grantType,
            ClientId: clientId,
            CodeVerifier: codeVerifier
        })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
                errorCallback();
            });
    },

    // Metodo per il refresh del token
    refreshToken: async (refreshToken: string, clientId: string, thenCallback: (data: any) => void, errorCallback: () => void) => {
        axios.post(`${apiUrls.getToken}`, {
            GrantType: 'refresh_token',
            ClientId: clientId,
            RefreshToken: refreshToken,
            Scope: 'openid profile email offline_access usl_vlm usl_telematics vlm_scope documentale_scope'
        })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);
                errorCallback();
            });
    }
}